import React, { useState } from 'react'
import Layout from '../../components/Layout'
import Container from '../../components/Container'
import Content from '../../components/Content'
import TabComponent from '../../components/Tabs'
import styles from './ImageGenerate.module.scss'
import { diseasesObj } from './utils'
import ImageReport from './ImageReport'

const ImageGenerate = () => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  const handleTabChange = (e) => {
    setSelectedIndex(e)
  }

  return (
    <Layout>
      <Container>
        <Content>
          <div className={styles.base}>
            <h3>Image Generation</h3>
            <TabComponent
              horizontal={false}
              selectedIndex={selectedIndex}
              onChange={handleTabChange}
              className={styles.tab}
            >
              {Object.keys(diseasesObj).map((disease) => {
                return (
                  <TabComponent.Panel
                    label={diseasesObj[disease]}
                  ></TabComponent.Panel>
                )
              })}
            </TabComponent>

            <div>
              {Object.keys(diseasesObj).map((disease, index) => (
                <ImageReport
                  key={index}
                  label={diseasesObj[disease]}
                  show={index === selectedIndex}
                />
              ))}
              {/* {selectedIndex === 0 && <ImageReport label={'flu'} show={true} />}
              {selectedIndex === 1 && (
                <ImageReport label={'covid'} show={true} />
              )} */}
            </div>
          </div>
        </Content>
      </Container>
    </Layout>
  )
}

export default ImageGenerate
